import { getQueryString } from './index'
// import SenguoFeedback from './feedback.plugin.min.js'

export const feedbackUrlTemplate = 'https://img.senguo.cc/assets/js/feedback-1.0.5-env.plugin.min.js'

export function feedbackEngine() {
    try {
        const shopId = getQueryString(window.location.hash, 'shopId') || localStorage.getItem('shopId')
        const shopType = 'new_ls'
        if (shopId == null) {
            return
        }
        if ((window as any).SenguoFeedback) {
            new (window as any).SenguoFeedback({
                shopId,
                shopType
            })
        }
    } catch (e) {
        console.error('Feedback调用失败\n', e)
    }
}

export function feedbackStarter() {
    const script = document.createElement('script')
    script.src = feedbackUrlTemplate.replace(/env/g, process.env.VUE_APP_ENV)
    console.log('feeback url ', script.src)
    script.onload = feedbackEngine
    script.onerror = (e) => {
        console.error('error\n', e)
    }
    document.body.appendChild(script)
}
